import { useAppDispatch, useAppSelector } from '../../../hooks/app'
import { getRequestFormData, setRequestFormData } from '../../../store/slices/request-signature.slice'
import { RATING_TYPES } from '../../../constants'

function StepSelectRatingType() {
    const requestFormData = useAppSelector(getRequestFormData)
    const dispatch = useAppDispatch()
    return (
        <div className="signature_step__two">
            <h3 className="heading3 text-center">Select Your Endorsement</h3>
            <div className="input_group">
                <label htmlFor="">Choose Rating Type</label>
                <select className="form-select" value={requestFormData.ratingType} onChange={(e) => {
                    dispatch(setRequestFormData({ ratingType: e.target.value }))
                    dispatch(setRequestFormData({ ratingModal: '' }))
                }}>
                    <option value="">Choose Rating Type</option>
                    {Object.keys(RATING_TYPES)?.map((key: any, i) => {
                        return <option value={key} key={i}>{RATING_TYPES[key]['label']}</option>
                    })}
                </select>
                <br />
                <label htmlFor="">Modal Type</label>
                <select className="form-select" onChange={(e) => dispatch(setRequestFormData({ ratingModal: e.target.value }))} value={requestFormData.ratingModal}>
                    <option value="">Modal Type</option>
                    {requestFormData.ratingType && Object.keys(RATING_TYPES[requestFormData.ratingType]['models'])?.map((model: string, i: number) => {
                        return <option value={model} key={i}>{RATING_TYPES[requestFormData.ratingType]['models'][model]}</option>
                    })}
                </select>
            </div>

        </div>
    )
}

export default StepSelectRatingType